import Vue from 'vue'
import VueI18n from 'vue-i18n'
import FlagIcon from 'vue-flag-icon'
import LocaleService from './../services/locale-service'
import Config from './../config'

Vue.use(VueI18n)
Vue.use(FlagIcon)

let messages = {};

Config.locales.forEach(locale => {
  messages[locale.code] = require(`./langs/${locale.code}.json`)
});

const i18n = new VueI18n({
  locale: LocaleService.getInitLocale(),
  fallbackLocale: 'en',
  messages
})

if (module.hot) {
  let hotLangFiles = Config.locales.map(locale => `./langs/${locale.code}.json`)

  module.hot.accept(hotLangFiles, () => {
    Config.locales.forEach(locale => i18n.setLocaleMessage(locale.code, require(`./langs/${locale.code}.json`)))
    console.log('hot reload', this, arguments)
  })
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js